import React, { useContext, useState,useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import { useReactToPrint } from "react-to-print";

//functions
import {
  _t,
  customStyle,
  formatPrice,
  getCookie,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import "react-datepicker/dist/react-datepicker.css";
import ChartOfAccPrint from "../transactions/ChartOfAccPrint";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const accountsLevels = [
  {
    id:1,
    name: "Level-1"
  },
  {
    id:2,
    name: "Level-2"
  },
  {
    id:3,
    name: "Complete"
  }
]

const AccountsReport = () => {
    const { t } = useTranslation();
    let { loading, setLoading, generalSettings } = useContext(SettingsContext);

    //toast obj
    let common_toast={
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    }

    //reportFields state
    const [reportFields,setReportFields]=useState(accountsLevels[2]);

    //report states
    const [reportData, setReportData] = useState([]);
    const [generateReport, setGenerateReport] = useState(false);
    const [option,setOption] = useState("view");

    const componentRef = useRef();
    const componentRef1 = useRef();

    const handleAccount=(account)=>{
      setReportFields(account)
    }

    const handleOption  = (e) =>{
      setOption(e.target.value)
    }

    const handleOnlyPrint = useReactToPrint({
      content: () => componentRef.current,
    });

    const handleSubmit=(e)=>{
      e.preventDefault();
      if(reportFields){
        // setLoading(true);
        const url = BASE_URL + "/settings/get-coa-level-wise-report";
        let formData = new FormData();
        formData.append('type', reportFields ? reportFields.name : "");

        return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setReportData(res.data);
          if(option !== "view"){
            setGenerateReport(true);
            componentRef1.current.handleDownload();
          }else{
            setTimeout(() => {
              handleOnlyPrint()          
            }, 200);
          }
          setLoading(false);
        })
        .catch((error) => {            
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`,common_toast);
        });
      }else{
        toast.error(`${_t(t("Please select from date & to date"))}`,common_toast);
      }
    }


  return (
    <>
    <Helmet>
      <title>{_t(t("Accounts Accounts Report"))}</title>
    </Helmet>
    <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table="table-to-xls"
      filename="Accounts Ledger Report"
      sheet="sheet 1"
      buttonText="Report"
      ref={componentRef1}
    />

    {/* excel */}
    <div className="d-none">
      {reportData && generateReport && Object.keys(reportData)?.length > 0 && (
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <table
                  className="table table-bordered table-hover min-table-height mt-3"
                  id="table-to-xls"
                >
                  <div className="page-break"></div>
                  <thead className="align-middle">
                    <tr style={{ border: "0px" }}>
                      <th colspan="3" style={{ border: "0px" }}>
                        <div className="row">
                          <div className="col-12">
                              <p className="my-2 xxslg-text">
                                {`${getSystemSettings(
                                    generalSettings,
                                    "siteName"
                                  )}`}
                              </p>

                              <p className="mt-1 xxslg-text">
                                {reportFields?.name}
                              </p>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {/* loop here*/}
                    {reportData && Object.keys(reportData)?.length > 0 && (
                      Object.keys(reportData)?.map((chartofAcc,index)=>{
                      const result = chartofAcc.replace(/^\d+-\d+-/, "");
                        return(
                          <>
                            <tr>
                              <td
                                scope="row"
                              >
                                <strong>{`${index + 1}. ${result}`}</strong>
                              </td>
                              <td
                                scope="row"
                              >
                                {chartofAcc}
                              </td>
                            </tr>
                            {reportData[chartofAcc] && typeof(reportData[chartofAcc]) === "object" && Object.keys(reportData[chartofAcc])?.length && Object.keys(reportData[chartofAcc]).map((chartofAccl2)=>{                                        
                              return (
                                <>
                                  <tr>
                                    <td></td>
                                    <td
                                      scope="row"
                                    >
                                      {chartofAccl2}
                                    </td>
                                  </tr>
                                  {reportData[chartofAcc] && reportData[chartofAcc][chartofAccl2] && Array.isArray(reportData[chartofAcc][chartofAccl2]) &&
                                    reportData[chartofAcc][chartofAccl2].map((chartofAccl3)=>{
                                      return (
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td
                                            scope="row"
                                          >
                                            {chartofAccl3}
                                          </td>
                                        </tr>
                                      )
                                    })
                                  }
                                </>
                              )
                            })}
                          </>
                        );
                      }))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <AccountsSidebar />
          </div>
          {/* left Sidebar ends */}
          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading}/>
                  {/* spin loading ends */}

                  {/* Loading effect */}
                  {/* {loading === true ? (
                    tableLoading()
                  ) : ( */}
                    <div key="fragment-3">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Accounts Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7 d-flex justify-content-end">
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <div className="d-inline mr-2 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="view_report"
                                name="view_report"
                                value="view"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={
                                  option === "view"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="view_report"
                                style={{fontSize:"16px",borderRadius:"5px"}}
                              >
                                <i class="fa fa-eye" aria-hidden="true"></i> {_t(t("View"))}
                              </label>
                            </div>
                          </div>
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="excel_report"
                              name="excel_report"
                              value="excel"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={
                                option === "excel"
                              }
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="excel_report"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i class="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                      >
                        <div className="col-12">
                          <div>                            
                            <div className="row">
                              <div className="form-group mt-2 col-3">
                                <div className="mb-2 text-left">
                                  <label
                                  htmlFor="transaction"
                                  className="control-label"
                                  >
                                  {_t(t("Level Of Account"))}                                  
                                  </label>
                                </div>
                                <Select
                                  options={accountsLevels ? accountsLevels : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={reportFields || ""}
                                  classNamePrefix="select table-text"
                                  onChange={(acc)=>handleAccount(acc)}                                
                                  placeholder={
                                      _t(t("Select acc")) + ".."
                                  }
                                  styles={customStyle}
                                  required
                                />
                              </div>

                              <div className="col-6"></div>
                            
                              <div className="form-group mt-4 col-3 text-right">                                                                                                                        
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded mt-2"
                                >
                                  <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Print Accounts"))}
                                </button>                                                                                                                                                                                       
                              </div>
                            </div>
                          </div>                                                                        
                        </div>
                      </form>
                    </div>
                </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
    <ChartOfAccPrint 
      name = {reportFields?.name}
      chartofAccPrint={reportData}
      ChartOfAcc={componentRef}
    />  
  </>
  )
}

export default AccountsReport;
